import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  EcosActionAnswerPictureResult,
  EcosActionResult,
  ListEcosActionsResult,
  ListEcosSectionsResult,
} from '../../../shared/models/api-results/ecos-correction-grid.api-result';
import { AddedEntity } from '../../../shared/models/api-results/base.api-result';
import {
  EcosActionAnswerPicturePayload,
  EcosActionAnswerTextPayload,
  EcosActionAnswerVideoPayload,
  EcosActionPayload,
  EcosSectionPayload,
} from '../../../shared/models/payloads/ecos-correction-grid.payload';
import { convertToFormData, prepareQueryParams } from '../../../shared/utils/api-transformations';
import { QueryData } from '../../../shared/models/payloads/query-data.payload';
import { DoActionPayload } from '../../../shared/models/payloads/ecos-session.payload';

@Injectable({
  providedIn: 'root',
})
export class HttpEcosCorrectionGridService {
  constructor(private http: HttpClient) {}

  getCorrectionGrid(id: string) {
    return this.http
      .get(
        `${environment.api_base_url}/ecos_sections/${id}/list_correction_grid_of_an_exam_content_ecos`
      )
      .pipe(map((res) => res as ListEcosSectionsResult));
  }

  wTestKeyword(examContentId: string, payload: DoActionPayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_sections/${examContentId}/test_answer_on_ecos`,
        payload
      )
      .pipe(
        // nnkitodo [v2later] fix api
        map((res: any) => {
          if (res?.ecosActionAnswerPicture)
            res.ecosActionAnswersPicture = res.ecosActionAnswerPicture;
          if (res?.ecosActionAnswerText) res.ecosActionAnswersText = res.ecosActionAnswerText;
          if (res?.ecosActionAnswerVideo) res.ecosActionAnswersVideo = res.ecosActionAnswerVideo;
          return res;
        }),
        map((res) => res as EcosActionResult)
      );
  }

  wAddEcosSection(id: string, payload: EcosSectionPayload) {
    return this.http
      .post(`${environment.api_base_url}/ecos_sections/add_ecos_section/${id}`, payload)
      .pipe(map((res) => res as AddedEntity));
  }

  wUpdateEcosSection(id: string, payload: EcosSectionPayload) {
    return this.http.post(
      `${environment.api_base_url}/ecos_sections/${id}/update_ecos_section`,
      payload
    );
  }

  wDeleteEcosSection(id: string) {
    return this.http.post(
      `${environment.api_base_url}/ecos_sections/${id}/delete_ecos_section`,
      {}
    );
  }

  wAddEcosAction(id: string, payload: EcosActionPayload) {
    return this.http
      .post(`${environment.api_base_url}/ecos_actions/add_ecos_action/${id}`, payload)
      .pipe(map((res) => res as AddedEntity));
  }

  wUpdateEcosAction(id: string, payload: EcosActionPayload) {
    return this.http.post(
      `${environment.api_base_url}/ecos_actions/${id}/update_ecos_action`,
      payload
    );
  }

  wDeleteEcosAction(id: string) {
    return this.http.post(`${environment.api_base_url}/ecos_actions/${id}/delete_ecos_action`, {});
  }

  wAddEcosActionAnswerText(id: string, payload: EcosActionAnswerTextPayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_actions_answer_text/add_ecos_action_answer_text/${id}`,
        payload
      )
      .pipe(map((res) => res as AddedEntity));
  }

  wAddEcosActionAnswerPicture(id: string, payload: EcosActionAnswerPicturePayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_actions_answer_picture/add_ecos_action_answer_picture/${id}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as EcosActionAnswerPictureResult));
  }

  wAddEcosActionAnswerVideo(id: string, payload: EcosActionAnswerVideoPayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_actions_answer_video/add_ecos_action_answer_video/${id}`,
        payload
      )
      .pipe(map((res) => res as AddedEntity));
  }

  wUpdateEcosActionAnswerText(id: string, payload: EcosActionAnswerTextPayload) {
    return this.http.post(
      `${environment.api_base_url}/ecos_actions_answer_text/update_ecos_action_answer_text/${id}`,
      payload
    );
  }

  wUpdateEcosActionAnswerPicture(id: string, payload: EcosActionAnswerPicturePayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_actions_answer_picture/update_ecos_action_answer_picture/${id}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as EcosActionAnswerPictureResult));
  }

  wUpdateEcosActionAnswerVideo(id: string, payload: EcosActionAnswerVideoPayload) {
    return this.http.post(
      `${environment.api_base_url}/ecos_actions_answer_video/update_ecos_action_answer_video/${id}`,
      payload
    );
  }

  wDeleteEcosActionAnswerText(id: string) {
    return this.http.post(
      `${environment.api_base_url}/ecos_actions_answer_text/${id}/delete_ecos_action_answer_text`,
      {}
    );
  }

  wDeleteEcosActionAnswerPicture(id: string) {
    return this.http.post(
      `${environment.api_base_url}/ecos_actions_answer_picture/delete_ecos_action_answer_picture/${id}`,
      {}
    );
  }

  wDeleteEcosActionAnswerVideo(id: string) {
    return this.http.post(
      `${environment.api_base_url}/ecos_actions_answer_video/delete_ecos_action_answer_video/${id}`,
      {}
    );
  }

  wWriterListEcosActions(params: QueryData) {
    return this.http
      .get(`${environment.api_base_url}/ecos_actions/list_my_ecos_actions`, {
        params: prepareQueryParams(params),
      })
      .pipe(map((res) => res as ListEcosActionsResult));
  }

  wProofReaderListEcosActions(params: QueryData) {
    return this.http
      .get(`${environment.api_base_url}/ecos_actions/list_ecos_actions`, {
        params: prepareQueryParams(params),
      })
      .pipe(map((res) => res as ListEcosActionsResult));
  }
}
